// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"10":"cc95341d","116":"25287384","178":"c6df922a","453":"a12e0131","721":"5a8caa6e","816":"408d3dca"}[chunkId] + ".css";
};